<template>
  <div>
    <v-tabs v-model="strTab" centered icons-and-text>
      <v-tab href="#tab-cadastro">
        Cadastro Geral
        <i :class="$utilidade.getIcone('cadastroGeral') + ' fa-2x'"></i>
      </v-tab>
    </v-tabs>

    <ed-form
      :formData="formData"
      :handlerSave="salvar"
      v-if="!this.$root.$session.loadingContent"
    >
      <cadastro-geral
        :formData="formData"
        v-show="strTab == 'tab-cadastro'"
        :key="'cadastro-' + $root.$session.versao"
      />
    </ed-form>
  </div>
</template>

<script>
import { EdForm } from "@/components/common/form";

import CadastroGeral from "./partials/geral.vue";

export default {
  name: "pageCadastroFuncao",
  props: {
    intExameId: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  components: {
    EdForm,
    CadastroGeral,
  },
  mounted() {
    this.getExame();
  },
  created() {},
  data() {
    return {
      strTab: "tab-cadastro",
      formData: {
        intId: 0,
        intTipoCategoriaId:null,
        strNome: null,
        strCodigoEsocial: null,
        strCodigoTuss: null,
        intOrdem: null,
        intInterpretacao: null,
        strPreparo: null,
        strObservacao: null,
        boolAtivo: 1,
      },
      boolCarregado: false,
    };
  },
  watch: {
    intExameId() {
      this.getExame();
    },
  },
  methods: {
    getExame() {
      if (!this.intExameId) {
        this.boolCarregado = true;
        return;
      }

      this.$root.$dialog.loading(true);

      this.$root.$request
        .get("Cadastro/Exame", { intId: this.intExameId })
        .then((objResponse) => {
          this.$root.$dialog.loading(false);

          if (objResponse.status == 200) {
            this.formData = Object.assign(objResponse.result, {});
          }
          this.boolCarregado = true;
        });
    },

    salvar() {
      this.$root.$request.post("Cadastro/Exame", this.formData).then((objResponse) => {
        if (objResponse.status == 200) {
          if (this.$route.name != "cadastro.exame.edit") {
            this.$router.push({
              name: "cadastro.exame.edit",
              params: { intId: objResponse.result.intId },
            });
          } else {
            this.getExame();
          }
        }
      });
    },
  },
};
</script>
